import { Alert, AlertTitle, Button, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { FallbackProps } from "react-error-boundary";

export function ErrorBoundaryFallback({ error, resetErrorBoundary }: FallbackProps) {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <Alert
            severity={"error"}
            action={
                <Stack direction={"row"} spacing={1}>
                    <Button color={"inherit"} onClick={resetErrorBoundary}>
                        Retry
                    </Button>
                    <Button color={"inherit"} sx={{ textWrapMode: "nowrap" }}>
                        {showDetails ? "Hide" : "Show"} Details
                    </Button>
                </Stack>
            }
            onClick={() => setShowDetails(!showDetails)}
        >
            <AlertTitle>Error</AlertTitle>
            An error occurred. Please reload the page or press the retry button.
            {!!error.message && (
                <Collapse in={showDetails}>
                    <Typography variant={"body2"} mt={1}>
                        {error.message}
                    </Typography>
                </Collapse>
            )}
        </Alert>
    );
}
